export default "__VITE_ASSET__$PU3Sitp__"